// Branch definitions used for pickup-location selection and lead routing.
// NOTE: the branch pickup / showroom availability rule layer was removed —
// state-level stock & pricing (product_location_settings) is the only
// availability source.

import type { AustralianState } from "@/lib/availability";

// Stable branch keys — rules are keyed by these, not by editable display names.
export interface BranchDef {
  key: string;
  name: string;
  state: AustralianState;
}

export const BRANCHES: BranchDef[] = [
  { key: "virginia", name: "Virginia", state: "QLD" },
  { key: "darra", name: "Darra", state: "QLD" },
  { key: "mount-druitt", name: "Mount Druitt", state: "NSW" },
  { key: "truganina", name: "Truganina", state: "VIC" },
  { key: "ridleyton", name: "Ridleyton", state: "SA" },
];

export function branchesForState(state: AustralianState | null): BranchDef[] {
  if (!state) return BRANCHES;
  return BRANCHES.filter((b) => b.state === state);
}

export function branchByKey(key: string | null | undefined): BranchDef | null {
  if (!key) return null;
  return BRANCHES.find((b) => b.key === key) ?? null;
}

export function branchNameForKey(key: string | null | undefined): string | null {
  return branchByKey(key)?.name ?? null;
}

// Maps a product's productType/category label to the stable category slug used
// by category_branch_rules. Returns null when there's no known indoor mapping.
export function productTypeToCategory(productType: string | null | undefined): string | null {
  if (!productType) return null;
  const t = productType.toLowerCase();
  if (t.includes("uv marble") || t.includes("marble sheet")) return "uv-marble-sheets";
  if (t.includes("ps cladding")) return "ps-cladding";
  if (t.includes("acoustic")) return "acoustic-cladding";
  if (t.includes("wet wall")) return "wet-wall-panels";
  if (t.includes("indoor") && t.includes("cladding")) return "indoor-cladding";
  return null;
}
